// extracted by mini-css-extract-plugin
export default {"footerWrapper":"styles_footerWrapper__JRRMA","footerWrapper_cefx":"styles_footerWrapper_cefx__29z-g","containerLogos":"styles_containerLogos__+tYnu"};